<div class="container-fluid">
  <h1 mat-dialog-title i18n>Add Note</h1>
  <div mat-dialog-content>
    <p i18n>To add a new note, complete the form below then click Submit.</p>
    <form #noteForm="ngForm" (ngSubmit)="addNote(noteForm)">
      <div class="form-group row">
        <label for="quoteNote_Text" class="col-sm-3 col-form-label" i18n>Description</label>
        <div class="col-sm-9">
          <textarea #quoteNote name="quoteNote_Text" id="quoteNote_Text"
                    [(ngModel)]="data.quoteNote_Text" #quoteNote_Text="ngModel"
                    class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div [hidden]="!noteForm.submitted || noteForm.valid"
           class="alert alert-danger" i18n>Validation issues encountered</div>
      <div class="mat-dialog-actions float-right">
        <div *ngIf="!isRequesting">
          <button type="submit" mat-button class="btn btn-bidit-submit mr-1" cdkFocusInitial i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </form>
  </div>
</div>
